import Action from '../../Action'
import './styles/ModalCreateException.css'
import { useState, useEffect } from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const ModalAddEvent = ({
  server,
  languaje,
  mode,
  setDataWorkFlow,
  dataWorkFlow,
  closeModal,
  SetElementList,
  elementsList,
  handleRemoveItem
}) => {


  const [disabled, setDisabled] = useState(true)


  const reqField = () => {
    return (
      <p className='reqField-gs'>
        *
      </p>
    )
  }



  const metricData = useFetch('cassia/workflow_events/by_trigger/' + dataWorkFlow.trigger_id, '', '', 'GET', server)
  // const metricData=useFetch('cassia/brands','','','GET',server)



  const changeOption = (option, index) => {
    let attr = ''
    if (option.filter == 'Marcas') {
      attr = 'brand_id'
    } else if (option.filter == 'hostModel') {
      attr = 'model_id'
    }
    else if (option.filter == 'period') {
      attr = 'agent_type_id'
    }
    else if (option.filter == 'trigger') {
      attr = 'value_type_id'
    }

    // setManttoData((prevState)=>{
    //     return {
    //         ...prevState,
    //         [attr]:option.value===""?0:(parseInt(option.value))
    //     }

    // })
    // setManttoRelation(option.value)
    setDataWorkFlow((prevState) => {
      return {
        ...prevState,
        ['workflow_eventid']: option.value === "" ? 0 : (parseInt(option.value))
      }

    })
    SetElementList((prevState) => {
      return {
        ...prevState,
        ['event']: option.label
      }

    })
  }

  const cancelItem = () => {
    setDataWorkFlow((prevState) => {
      return {
        ...prevState,
        ['workflow_eventid']: 0
      }

    })
    SetElementList((prevState) => {
      return {
        ...prevState,
        ['event']: ""
      }

    })
    handleRemoveItem({ id: 'event', label: capitalizeFirstLetter(lang[languaje]['evento']), type: 'event' })
    closeModal()
  }
  const handleChange = (e) => {
    let attr = e.target.name
    // let val()
    //  if(attr=="ticket_auto"){
    //   attr=0'
    //  }
    setDataWorkFlow((prevState) => {
      return {
        ...prevState,
        [attr]: e.target.value == "true" ? false : true
      }

    })
  }


  const { workflow_eventid, event_auto_close, ticket_auto } = dataWorkFlow;
  return (
    <div className="modal-GS-content">
      <div className='card-modal-gs modal-verificate'>
        <div className='head-card-modal-gs'>
          <div className='title-head-card-modal-gs'>
            {(lang[languaje]['agregar'].toUpperCase()) + ' ' + lang[languaje]['evento'].toUpperCase()}
          </div>
        </div>
        <div className='content-card-modal-gs' style={{ overflowY: 'scroll', scrollbarWidth: 'thin' }}>

          <div className="form-GS-box">

            <div className="user-box-GS " style={{ height: '40%' }}>
              <label className='label-GS' style={{ top: '2%' }}>{capitalizeFirstLetter(lang[languaje]['evento'])}{(workflow_eventid == 0) ? reqField() : ''}</label>
              {
                (metricData.loading) ? <p style={{ color: 'var(--txt-color)' }}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p> :
                  <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''} opt_de={(metricData == null) ? 0 : metricData} origen={'Admin'} data={metricData.data.data} loading={metricData.loading} titulo='Event' selectFunction={changeOption} index={0}></SelectorAdmin>
              }
            </div>
            <div className="user-box-GS" style={{ height: '15%' }}>

              <input
                required
                name="ticket_auto"

                defaultChecked={false}
                className='checkbox-gs'
                type="checkbox"
                value={ticket_auto}
                onChange={handleChange}
              />

              <label className='label-checkbox-gs'>{capitalizeFirstLetter(lang[languaje]['ticketAuto'])}</label>
            </div>
            <div className="user-box-GS" style={{ height: '15%' }}>

              <input
                required
                name="event_auto_close"

                defaultChecked={false}
                className='checkbox-gs'
                type="checkbox"
                value={event_auto_close}
                onChange={handleChange}
              />

              <label className='label-checkbox-gs'>{capitalizeFirstLetter(lang[languaje]['cierreAuto'])}</label>
            </div>




            <div className="user-box-GS" style={{ height: '30%' }}>
              {

                <>
                  <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])} action={cancelItem} />
                  <Action disabled={(workflow_eventid == 0 ? true : false)} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])} action={closeModal} />
                </>
                // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
              }

              {
                // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
              }

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalAddEvent